import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // H5通知待办
  getUpcomingList(_postData) {
    return http.get(URL.API_UPCOMING_LIST, _postData)
  },
  // H5消息中心
  getMessageFlow(_postData) {
    return http.get(URL.API_MESSAGE_FLOW, _postData)
  },
  // 查询今日请假状态
  getTodayLeaveStatus(_postData) {
    return http.get(URL.API_LEAVE_GET_TODAY_LEAVE_STATUS, _postData)
  }
}
